<a
  class="{{styleClass}}-button v-button {{ !isFullWidth ? 'w-min whitespace-nowrap' : 'w-full' }}"
  [ngClass]="className"
  href="{{buttonLink}}"
  (click)="onClick($event)"
  (keypress.enter)="onClick($event)"
  [attr.data-formelementid]="dataFormElementId ? dataFormElementId : null"
  [attr.target]="target"
  [rel]="rel"
  [attr.aria-disabled]="disabled ? 'true' : null"
  [attr.tabindex]="disabled ? -1 : null"
  [attr.aria-labelledby]="getIdToAriaLabelledbyContext(text, buttonLink)"
  >
  <span class="md:whitespace-nowrap"
    [ngClass]="buttonSizeClass"
    [class.tertiary-no-underline]="useIcon && buttonStyle ===  'tertiary'">
    {{text}}
    @if (linkIcon && useIcon && buttonStyle==='tertiary') {
      <fa-icon
        class="arrow-right fa-1x pl-1"
        [icon]="linkIcon"
        >
      </fa-icon>
    }
  </span>
  <!-- Hidden Context -->
  <span [attr.id]="getIdToAriaLabelledbyContext(text, buttonLink)" class="sr-only">{{getTextContext(buttonLink)}}</span>
</a>
